"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function SwapRight(props) {
    return (react_1.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 12 6" },
        react_1.default.createElement("polygon", { fill: "currentColor", points: "80.611 13.895 83.564 10.941 80.611 7.988 80.611 10.436 72.6 10.436 72.6 11.447 80.611 11.447", transform: "translate(-72 -8)" })));
}
exports.default = SwapRight;
//# sourceMappingURL=SwapRight.js.map